<template>
    <input class="form-input rounded-md border border-solid border-black text-gray-700 text-right py-2 px-3"
           v-bind:class="isFilled"
           v-money="money"
           :value="value"
           @blur="verifyMaxMin"
           @input="$emit('input', $event.target.value)" ref="input">
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        precision: {
            type: Number,
            default: 2
        },
        colored: {
            type: Boolean,
            default: false
        },
        interval: {
            type: Array,
            default: null
        }
    },
    computed: {
        isFilled: function () {
            return this.bgColor()
        }
    },
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                precision: this.precision,
                masked: false
            },
        }
    },
    methods: {
        verifyMaxMin() {
            if (this.interval && (this.interval[0] && this.interval[1])) {
                let max = this.interval[0];
                let min = this.interval[1];
                let val = this.value;

                if ("string" === typeof val) {
                    val = parseFloat(val.replace(".", "").replace(",", "."))
                }
                if ("string" === typeof max) {
                    max = parseFloat(max.replace(".", "").replace(",", "."))
                }
                if ("string" === typeof min) {
                    min = parseFloat(min.replace(".", "").replace(",", "."))
                }

                if (val > max) {
                    this.$emit("input", this.interval[0]);
                } else if (val < min) {
                    this.$emit("input", this.interval[1]);
                }
            }
        },
        focus() {
            this.$refs.input.focus()
        },
        bgColor() {
            let val = this.value;
            if ("string" === typeof this.value) {
                val = parseFloat(this.value.replace(',', '.'));
            }
            return {
                'bg-green-100': this.colored && val > 0,
                'bg-red-100': this.colored && val < 0,
            }
        }
    },
    watch: {
        precision: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.precision = newVal;
                this.money.precision = newVal
            }
        }
    }
}
</script>

